export default "__VITE_ASSET__CVlgbpLR__"